//
import { find } from 'shelljs';
import Formatter from './geoUtil'



// 瓦片编号转经纬度
function tile2lon(x, z) {
    return x / Math.pow(2.0, z) * 360.0 - 180;
}

function tile2lat(y, z) {
    let n = Math.PI - (2.0 * Math.PI * y) / Math.pow(2.0, z);
    return toDegrees(Math.atan(Math.sinh(n)));
}


function toDegrees(radians) {
    return radians * (180 / Math.PI);
}


function tile2boundingBox(x, y, zoom) {
    return {
        north: tile2lat(y, zoom),
        south: tile2lat(y + 1, zoom),
        west: tile2lon(x, zoom),
        east: tile2lon(x + 1, zoom)
    }
}


function findDivisibleBy1000(a, b) {
    const result = [];

    // 确保 a 是较小的数，b 是较大的数
    const start = Math.min(a, b);
    const end = Math.max(a, b);

    // 找到第一个大于等于 start 且能整除 1000 的数
    const firstDivisible = Math.ceil(start / 1000) * 1000;

    // 遍历所有能整除 1000 的数
    for (let num = firstDivisible; num <= end; num += 1000) {
        result.push(num);
    }

    return result;
}

/**
 * 从左上角 开始 顺时针分别为1234
 * @param {图片} image 
 * @param {信息} info 
 */
export function drawGaussGrid(ctx, width, height, padding, minX, minY, maxX, maxY, zoom, addCoordText) {
    // 在图片上添加文字
    ctx.font = '30px Arial'; // 设置字体大小和字体
    ctx.fillStyle = 'black'; // 设置文字颜色
    ctx.textAlign = 'left'; // 设置文字水平居中
    ctx.textBaseline = 'top'; // 设置文字垂直居中

    let b1 = tile2boundingBox(minX, minY, zoom)
    let p1 = { lat: b1.north, lng: b1.west }

    let b2 = tile2boundingBox(maxX, minY, zoom)
    let p2 = { lat: b2.north, lng: b2.east }
    let b3 = tile2boundingBox(maxX, maxY, zoom)
    let p3 = { lat: b3.south, lng: b3.east }
    let b4 = tile2boundingBox(minX, maxY, zoom)
    let p4 = { lat: b4.south, lng: b4.west }

    console.log(p1, p2, p3, p4)

    let xy1 = Formatter.WGS84ToCGCS2000(p1, '6')
    let xy2 = Formatter.WGS84ToCGCS2000(p2, '6')
    let xy3 = Formatter.WGS84ToCGCS2000(p3, '6')
    let xy4 = Formatter.WGS84ToCGCS2000(p4, '6')

    console.log(xy1, xy2, xy3, xy4)

    let xLeftArray = findDivisibleBy1000(xy1.y, xy4.y)
    let xRightArray = findDivisibleBy1000(xy2.y, xy3.y)

    if (xRightArray.length > 0 && xLeftArray.length > 0) {
        // 计算左侧和右侧的 x 跨度
        const xSpanLeft = Math.abs(xy1.y - xy4.y);
        const xSpanRight = Math.abs(xy2.y - xy3.y);

        // 计算左侧和右侧的起始点
        const xStartLeft = Math.min(xy1.y, xy4.y);
        const xStartRight = Math.min(xy2.y, xy3.y);

        // 计算每像素对应的 x 值
        const xPerPixelLeft = height / xSpanLeft;
        const xPerPixelRight = height / xSpanRight;

        // 遍历左侧和右侧的 x 值
        for (const xLeft of xLeftArray) {
            for (const xRight of xRightArray) {
                if (xLeft === xRight) {
                    // 计算对应的 y 值
                    const yLeft = (xLeft - xStartLeft) * xPerPixelLeft;
                    const yRight = (xRight - xStartRight) * xPerPixelRight;

                    const p1 = [0 + padding, height - Math.round(yLeft)], p2 = [width + padding, height - Math.round(yRight)]
                    ctx.beginPath();
                    ctx.moveTo(p1[0], p1[1]);
                    ctx.lineTo(p2[0], p2[1]);
                    ctx.stroke();

                    if (addCoordText) {
                        ctx.textAlign = 'left'
                        ctx.fillText(`${xLeft}`, p1[0], p1[1]);
                        ctx.textAlign = 'right'
                        ctx.fillText(`${xRight}`, p2[0], p2[1]);
                    }
                }
            }
        }
    }


    let yTopArray = findDivisibleBy1000(xy1.x, xy2.x)
    let yBottomArray = findDivisibleBy1000(xy3.x, xy4.x)

    if (yTopArray.length > 0 && yBottomArray.length > 0) {
        // 计算左侧和右侧的 x 跨度
        const ySpanTop = Math.abs(xy1.x - xy2.x);
        const ySpanBottom = Math.abs(xy3.x - xy4.x);

        // 计算左侧和右侧的起始点
        const yStartTop = Math.min(xy1.x, xy2.x);
        const yStartBottom = Math.min(xy3.x, xy4.x);

        // 计算每像素对应的 x 值
        const yPerPixelTop = width / ySpanTop;
        const yPerPixelBottom = width / ySpanBottom;

        // 遍历左侧和右侧的 x 值
        for (const yTop of yTopArray) {
            for (const yBottom of yBottomArray) {
                if (yTop === yBottom) {
                    // 计算对应的 y 值
                    const xTop = (yTop - yStartTop) * yPerPixelTop;
                    const xBottom = (yBottom - yStartBottom) * yPerPixelBottom;

                    const p1 = [Math.round(xTop), 0 + padding], p2 = [Math.round(xBottom), height + padding]

                    ctx.beginPath();
                    ctx.moveTo(p1[0], p1[1]);
                    ctx.lineTo(p2[0], p2[1]);
                    ctx.stroke();

                    if (addCoordText) {
                        ctx.textAlign = 'center'
                        ctx.textBaseline = 'bottom'; // 设置文字垂直居中
                        ctx.fillText(`${yTop}`, p1[0], p1[1]);
                        ctx.textBaseline = 'top';
                        ctx.fillText(`${yBottom}`, p2[0], p2[1]);

                    }


                }
            }
        }
    }



}


//
/**
 * 
 * @param {图片} image 
 * @param {信息} info 
 */
export function drawLatLngGrid(image, info) {

}


// WEBPACK FOOTER //
// ./src/util/grid.js